import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link as ScrollLink } from 'react-scroll';
import CallButton from '../Header/callbutton';
import Phone from '../../assets/images/phone.svg';
import './Navbar.css';
import Panel from './Panel';
import downarrow from '../../assets/images/downarrow.svg';
import SidebarMenu from './SidebarMenu';
import WineryPanel from '../../Winery Products/WineryPanel';
import Partners from '../../Partners/Partners';

const Navbar = () => {
  const location = useLocation();
  const isProductPage = location.pathname === '/Product';
  const isWineryPage = location.pathname === '/WineryProducts';
  const isPartnersPage = location.pathname === '/Partners';

  const [isClicked, setClick] = useState(false);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isWineryPanelOpen, setIsWineryPanelOpen] = useState(false);
  const [panelTimeout, setPanelTimeout] = useState(null);

  const toggleMenu = () => {
    setClick(!isClicked);
    closeAllPanels();
  };

  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
    setIsWineryPanelOpen(false);
    resetPanelTimeout();
  };

  const toggleWineryPanel = () => {
    setIsWineryPanelOpen(!isWineryPanelOpen);
    setIsPanelOpen(false);
    resetPanelTimeout();
  };

  const closePanel = () => {
    setIsPanelOpen(false);
    clearPanelTimeout();
  };

  const closeWineryPanel = () => {
    setIsWineryPanelOpen(false);
    clearPanelTimeout();
  };

  const closeAllPanels = () => {
    setIsPanelOpen(false);
    setIsWineryPanelOpen(false);
    clearPanelTimeout();
  };

  const resetPanelTimeout = () => {
    clearPanelTimeout();
    const timeout = setTimeout(() => {
      closeAllPanels();
    }, 10000); // 10 წამი
    setPanelTimeout(timeout);
  };

  const clearPanelTimeout = () => {
    if (panelTimeout) clearTimeout(panelTimeout);
  };

  const handleMouseEnter = () => {
    clearPanelTimeout();
  };

  const handleMouseLeave = () => {
    resetPanelTimeout();
  };

  const { t, i18n } = useTranslation();
  const languageClass = i18n.language === 'ka' ? 'georgian' : 'english';

  return (
    <nav className={`navbar ${isProductPage ? 'product-page' : ''} ${isWineryPage ? 'wineryProducts-page' : ''} ${isPartnersPage ? 'Partners-page' : ''} ${languageClass}`}>
      <div className="navbar-links">
        <div className={`menu-icon ${isClicked ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>

        <SidebarMenu isOpen={isClicked} toggleMenu={toggleMenu} />

        {!isClicked && (
          <div className="nav-menu">
            <ScrollLink to="/about" className="nav-button navlink">
              {t('About us')}
            </ScrollLink>

            <button 
              className={`nav-button navB same1 ${languageClass}`} 
              onClick={toggleWineryPanel}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <h1>{t('Oenological Products')}</h1>
              <img src={downarrow} alt="dropdown" />
              {isWineryPanelOpen && (
                <WineryPanel className="panel" closePanel={closeWineryPanel} />
              )}
            </button>

            <button 
              className={`nav-button navB same2 ${languageClass}`}  
              onClick={togglePanel}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <h1>{t('Equipment')}</h1>
              <img src={downarrow} alt="dropdown" />
              {isPanelOpen && (
                <Panel className="panel" closePanel={closePanel} />
              )}
            </button>

            <ScrollLink to="/service" className={`nav-button navlink ${languageClass}`}>
              {t('Service')}
            </ScrollLink>

            <Link to="/Partners" className="nav-button navlink">
              {t('Partners')}
            </Link>

            <CallButton
              className={`call-button navlink ${isProductPage ? 'product-page-phone' : ''}`}
              onClick={() => window.location.href = 'tel:+995591090997'}
            >
              <img src={Phone} alt="Call" /> (+995) 591 09 09 97
            </CallButton>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;